import { Buffer } from "buffer";
import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import * as serviceworker from './serviceWorker';
import App from "./App";

window.Buffer = Buffer;

ReactDOM.render(
	<CssBaseline>
		<App />
	</CssBaseline>,
	document.getElementById("root"),
	() => {
		window.finishProgress();
	}
);

// O service worker mantinha o app preso a um bundle antigo depois de cada deploy
// (o navegador continuava pedindo um main.*.js que já não existe, e o fallback do
// SPA devolvia index.html no lugar do JS, quebrando a aplicação). Desregistramos
// para que cada deploy seja carregado de fato.
serviceworker.unregister();
